import { render, staticRenderFns } from "./ResetPasswordEmailCard.vue?vue&type=template&id=ba12cc84&scoped=true&"
import script from "./ResetPasswordEmailCard.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordEmailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba12cc84",
  null
  
)

export default component.exports